import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/siswa";
var post = "/siswa";
export const actGetDataSiswa = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_SISWA_SISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_SISWA_SISWA",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_SISWA_SISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_SISWA",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataSiswa = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_SISWA_SISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Student has been created");
          dispatch(__openModal({ modal: "MODAL_ADD_SISWA", open: false }));
          return dispatch(actGetDataSiswa());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_SISWA_SISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_SISWA",
          message: "Network error..",
        });
      });
  };
};
export const actUpdatePasswordSiswa = (params) => {
  return (dispatch) => {
    let config = CONFIG_({
      url: "/siswa-setpassword",
      data: params,
      method: "POST",
    });
    dispatch({ type: "LOADING_SISWA_SISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Password has been update");
          dispatch(__openModal({ modal: "MODAL_SET_PASSWORD", open: false }));
          return dispatch(actGetDataSiswa());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_SISWA_SISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_SISWA",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataSiswa = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_SISWA_SISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Student has been update");
          return dispatch(actDetailDataSiswa({ id: id }));
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_SISWA_SISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_SISWA",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataSiswa = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_SISWA_SISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_SISWA_DETAIL",
            message: "Success get data",
            id: id,
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_SISWA_SISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_SISWA",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataSiswa = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_SISWA_SISWA" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Student has been deleted");
          return dispatch(actGetDataSiswa());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_SISWA_SISWA", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_SISWA_SISWA",
          message: "Network error..",
        });
      });
  };
};
